import { EmbedType, MeetingSummaryElement } from './models'
import { nanoid } from 'nanoid'

export const parseMeetingSummary = (meetingSummary: string): MeetingSummaryElement[] => {
  const result: MeetingSummaryElement[] = []
  try {
    const regex = /(<[^/][^>]*>)*@embed\((\w+)\((\{.*?}|\s*)\)\)\s*(<\/[^>]+>)*/g
    const matches = meetingSummary.matchAll(regex)
    let lastIndex = 0

    for (const match of matches) {
      const [fullMatch, , embedType, embedParamsStr] = match

      if (match.index && match.index > lastIndex) {
        const freeText = meetingSummary.slice(lastIndex, match.index).trim()
        if (freeText) {
          result.push({ displayId: nanoid(), type: 'text', text: freeText })
        }
      }
      const embedParams = embedParamsStr.trim() ? JSON.parse(embedParamsStr) : {}

      result.push({
        displayId: embedParams.displayId ?? nanoid(),
        type: 'embed',
        embedType: embedType as EmbedType,
        parameters: embedParams,
      })

      lastIndex = (match.index ?? 0) + fullMatch.length
    }

    const remainingText = meetingSummary.slice(lastIndex).trim()
    if (remainingText) {
      result.push({ displayId: nanoid(), type: 'text', text: remainingText })
    }
  } catch (e) {
    console.error(e)
  }

  return result
}

export const convertMeetingSummaryElementToString = (element: MeetingSummaryElement): string => {
  const { type } = element
  switch (type) {
    case 'text':
      return element.text
    case 'embed': {
      const { embedType } = element
      switch (embedType) {
        case EmbedType.MEETING_RESULT:
          return formatEmbedPlaceholder(embedType, element.parameters)
        case EmbedType.PARTICIPANTS:
        case EmbedType.MEETING_INFO:
          return formatEmbedPlaceholder(embedType)
      }
    }
  }
}

const formatEmbedPlaceholder = (embedType: string, embedParameters: { [key: string]: unknown } = {}) => {
  return `\n@embed(${embedType}(${JSON.stringify(embedParameters)}))\n`
}
